export default __webpack_public_path__ + "static/media/quantity_blue_icon.d89ab2d1.svg";